<ion-icon class="size-icon" [color]="color" [name]="icon"></ion-icon>
